@if (statusForm()) {
<form [formGroup]="statusForm()">
    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Slug</label>
        <div class="col-md-8">
            @if (mode() === formMode.CREATE) {
                <input type="text" class="form-control text-uppercase" formControlName="slug"
                    placeholder="EJ. CUSTOM_REVIEW" (blur)="statusForm().get('slug')?.setValue(($any($event.target).value || '').toUpperCase())">
                @if (statusForm().get('slug')?.errors?.['required'] && statusForm().get('slug')?.touched) {
                    <div><small class="text-danger">Slug es requerido.</small></div>
                }
                @if (statusForm().get('slug')?.errors?.['pattern'] && statusForm().get('slug')?.touched) {
                    <div><small class="text-danger">Use UPPER_SNAKE (letras, números y _).</small></div>
                }
            } @else {
                <div class="form-group mb-0">
                    <strong><code>{{ statusForm().get('slug')?.value }}</code></strong>
                    @if (slugLocked()) {
                        <div class="form-text small">Slug de sistema: no se puede cambiar.</div>
                    } @else {
                        <div class="form-text small">El slug no se edita aquí para evitar romper referencias.</div>
                    }
                </div>
            }
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Código</label>
        <div class="col-md-8">
            <input type="number" class="form-control" formControlName="code">
            @if (statusForm().get('code')?.errors?.['required'] && statusForm().get('code')?.touched) {
                <div><small class="text-danger">Código es requerido.</small></div>
            }
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Nombre</label>
        <div class="col-md-8">
            <input type="text" class="form-control" formControlName="name" placeholder="Etiqueta visible">
            @if (statusForm().get('name')?.errors?.['required'] && statusForm().get('name')?.touched) {
                <div><small class="text-danger">Nombre es requerido.</small></div>
            }
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Categoría</label>
        <div class="col-md-8">
            <select class="form-select" formControlName="category">
                @for (cat of categories; track cat.value) {
                    <option [ngValue]="cat.value">{{ cat.label }}</option>
                }
            </select>
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Estilo (badge)</label>
        <div class="col-md-8">
            <input type="text" class="form-control mb-2" formControlName="style"
                placeholder="border-success text-success">
            <div class="d-flex flex-wrap gap-1 mb-2">
                @for (preset of stylePresets; track preset) {
                    <button type="button" class="btn btn-outline-secondary btn-xs" (click)="applyPreset(preset)">
                        <span class="badge" [ngClass]="preset">Aa</span>
                    </button>
                }
            </div>
            <div>
                <span class="small text-muted me-2">Vista previa:</span>
                <span class="badge border" [ngClass]="previewStyle()">
                    <i [class]="previewIcon()" class="me-1"></i>{{ previewName() }}
                </span>
            </div>
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Icono</label>
        <div class="col-md-8">
            <div class="input-group mb-2">
                <span class="input-group-text"><i [class]="previewIcon()"></i></span>
                <input type="text" class="form-control" formControlName="icon"
                    placeholder="Ej. fas fa-check-circle">
            </div>
            <div class="d-flex flex-wrap gap-1">
                @for (icon of iconPresets; track icon) {
                    <button type="button" class="btn btn-outline-secondary btn-xs"
                        [class.active]="previewIcon() === icon"
                        (click)="applyIcon(icon)"
                        [title]="icon">
                        <i [class]="icon"></i>
                    </button>
                }
            </div>
            <div class="form-text">Se usa en trazabilidad BPM y badges de estado.</div>
        </div>
    </div>

    <div class="form-group row mb-3">
        <label class="col-md-4 col-form-label">Label al aprobar</label>
        <div class="col-md-8">
            <input type="text" class="form-control" formControlName="approvedLabel"
                placeholder="Ej. Enviado, Aprobado, Pagado">
            <div class="form-text">
                Texto en la bandeja cuando este estado ya se aprobó / pasó
                (ej. Borrador → <em>Enviado</em>, Pendiente → <em>Aprobado</em>).
            </div>
        </div>
    </div>

    <div class="form-group row mb-1">
        <label class="col-md-4 col-form-label">Activo</label>
        <div class="col-md-8 d-flex align-items-center">
            <div class="form-check form-switch mb-0">
                <input class="form-check-input" type="checkbox" role="switch" formControlName="isActive" id="status-active">
                <label class="form-check-label" for="status-active">
                    {{ statusForm().get('isActive')?.value ? 'Visible en selectores' : 'Oculto (desactivado)' }}
                </label>
            </div>
        </div>
    </div>
</form>
}
